import React, { Component } from 'react';

export class ChecklistIcon extends Component {
  static displayName = 'ChecklistIcon';

  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="142" height="120" viewBox="0 0 142 120">
        <g fill="none" fillRule="nonzero">
          <path
            fill="#75C7F7"
            d="M98.79 90.276l-53.46 24.958a6 6 0 0 1-7.976-2.898L.551 33.503a6 6 0 0 1 2.9-7.975L56.91.57a6.001 6.001 0 0 1 7.975 2.898L101.688 82.3a6 6 0 0 1-2.898 7.975"
          />
          <path
            fill="#65BAF0"
            d="M29 23v71.44l8.354 17.895a5.999 5.999 0 0 0 7.975 2.898l1.67-.78V17H35a6 6 0 0 0-6 6"
          />
          <path
            fill="#9DD7F9"
            d="M103.987 119.983h-64.96a6 6 0 0 1-6-6V19.017a6 6 0 0 1 6-6h50.951l20.01 19.966v81a6 6 0 0 1-6 6"
          />
          <path fill="#89CFF8" d="M109.99 36.983l-14 .006a6 6 0 0 1-6.003-5.997l-.008-18 20.008 19.99.003 4z" />
          <path fill="#C4E7FC" d="M109.987 32.983l-14 .006a6 6 0 0 1-6.001-5.997l-.008-14 20.01 19.99z" />
          <path
            fill="#89CFF8"
            d="M110 87l-13.01.06a4 4 0 0 0-3.99 4v23.071a1 1 0 0 0 1.555.832l3.438-2.29a3.99 3.99 0 0 1 2.218-.673H110V87z"
          />
          <path fill="#459FED" d="M97 104v6.131a1 1 0 0 0 1.555.832l3.438-2.29a3.99 3.99 0 0 1 2.218-.673H105v-4h-8z" />
          <path
            fill="#459FED"
            d="M101 108h20a4 4 0 0 0 4-4V87.01a4 4 0 0 0-4.01-4l-20 .05a4 4 0 0 0-3.99 4V104a4 4 0 0 0 4 4"
          />
          <path
            fill="#D8EFFD"
            d="M117.149 101.883a9.915 9.915 0 0 1-6.15 2.12c-2.32 0-4.46-.79-6.15-2.12a7.977 7.977 0 0 1 6.15-2.88 7.977 7.977 0 0 1 6.15 2.88"
          />
          <path fill="#B2E0FA" d="M111 101a2 2 0 0 1-2-2v-2a2 2 0 0 1 4 0v2a2 2 0 0 1-2 2" />
          <path fill="#D8EFFD" d="M115.5 96h-9a1.5 1.5 0 0 1 0-3h9a1.5 1.5 0 1 1 0 3" />
          <path fill="#D8EFFD" d="M111 87c2.76 0 5 2.238 4.999 5v2h-10v-2a4.999 4.999 0 0 1 5-5" />
          <path fill="#D8EFFD" d="M111 99a4 4 0 0 1-4-4v-4h8v4a4 4 0 0 1-4 4" />
          <path fill="#B2E0FA" d="M110 88h2a3 3 0 0 1 3 3v2h-1a4 4 0 0 1-4-4v-1z" />
          <path fill="#D8EFFD" d="M111 87a4 4 0 0 1 4 4h-2a3 3 0 0 1-3-3 1 1 0 0 1 1-1" />
          <path fill="#B2E0FA" d="M110 88.243h-1a2 2 0 0 0-2 2V92h1a2 2 0 0 0 2-2v-1.758z" />
          <path fill="#D8EFFD" d="M110 88h-1a2 2 0 0 0-2 2v1h1a2 2 0 0 0 2-2v-1z" />
          <path fill="#C4E7FC" d="M55 63h-5a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2" />
          <path
            fill="#FFF"
            d="M94 60H64a1 1 0 1 1 0-2h30a1 1 0 1 1 0 2M53 61a.995.995 0 0 1-.707-.293l-2-2a.999.999 0 1 1 1.414-1.414l1.226 1.226 4.299-5.16c.353-.423.984-.48 1.408-.128.424.354.482.985.128 1.41l-5 6c-.18.215-.442.345-.723.358L53 61"
          />
          <path fill="#C4E7FC" d="M55 77h-5a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2" />
          <path fill="#FFF" d="M94 74H64a1 1 0 1 1 0-2h30a1 1 0 1 1 0 2" />
          <path fill="#C4E7FC" d="M55 49h-5a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2" />
          <path
            fill="#FFF"
            d="M94 46H64a1 1 0 1 1 0-2h30a1 1 0 1 1 0 2M53 47a.995.995 0 0 1-.707-.293l-2-2a.999.999 0 1 1 1.414-1.414l1.226 1.226 4.299-5.16c.353-.423.984-.48 1.408-.128.424.354.482.985.128 1.41l-5 6c-.18.215-.442.345-.723.358L53 47M52.517 102h-.02c-1.967-.009-2.89-1.54-2.928-1.606a.502.502 0 0 1 .178-.685.502.502 0 0 1 .684.177c.033.055.692 1.108 2.072 1.114h.014c.718 0 1.31-.22 1.666-.62.24-.27.35-.61.309-.956-.075-.612-.51-.923-1.944-1.386-1.466-.457-2.856-.89-3.032-2.342a2.196 2.196 0 0 1 .555-1.742c.549-.616 1.404-.954 2.41-.954h.022c1.968.01 2.89 1.54 2.929 1.605a.5.5 0 0 1-.863.506c-.026-.042-.684-1.105-2.071-1.11-.707-.043-1.322.216-1.68.618-.241.271-.351.61-.31.956.085.694.659.985 2.343 1.51 1.349.436 2.474.902 2.634 2.218a2.2 2.2 0 0 1-.555 1.742c-.55.616-1.405.955-2.413.955"
          />
          <path
            fill="#FFF"
            d="M52.5 93.635a.5.5 0 0 1-.5-.5V92.5a.5.5 0 0 1 1 0v.635a.5.5 0 0 1-.5.5M52.5 103a.5.5 0 0 1-.5-.5v-.98a.5.5 0 1 1 1 0v.98a.5.5 0 0 1-.5.5"
          />
          <path fill="#D8EFFD" d="M57 108h-9a1 1 0 1 1 0-2h9a1 1 0 1 1 0 2" />
          <path
            fill="#459FED"
            d="M142 75v6.131a1 1 0 0 1-1.555.832l-3.437-2.29a3.992 3.992 0 0 0-2.22-.673H134v-4h8z"
          />
          <path
            fill="#459FED"
            d="M138 79h-20a4 4 0 0 1-4-4V58.01a4 4 0 0 1 4.01-4l20 .05a4 4 0 0 1 3.99 4V75a4 4 0 0 1-4 4"
          />
          <path
            fill="#D8EFFD"
            d="M121.851 72.883a9.915 9.915 0 0 0 6.15 2.12c2.32 0 4.46-.79 6.15-2.12a7.977 7.977 0 0 0-6.15-2.88 7.977 7.977 0 0 0-6.15 2.88"
          />
          <path fill="#B2E0FA" d="M128 72a2 2 0 0 0 2-2v-2a2 2 0 0 0-4 0v2a2 2 0 0 0 2 2" />
          <path fill="#D8EFFD" d="M123.5 67h9a1.5 1.5 0 1 0 0-3h-9a1.5 1.5 0 1 0 0 3" />
          <path fill="#D8EFFD" d="M128 58c-2.76 0-5 2.238-4.999 5v2h10v-2.002A5 5 0 0 0 128 58" />
          <path fill="#D8EFFD" d="M128 70a4 4 0 0 0 4-4v-4h-8v4a4 4 0 0 0 4 4" />
          <path fill="#B2E0FA" d="M129 59h-2a3 3 0 0 0-3 3v2h1a4 4 0 0 0 4-4v-1z" />
          <path fill="#D8EFFD" d="M128 58a4 4 0 0 0-4 4h2a3 3 0 0 0 3-3 1 1 0 0 0-1-1" />
          <path fill="#B2E0FA" d="M129 59.243h1a2 2 0 0 1 2 2V63h-1a2 2 0 0 1-2-2v-1.758z" />
          <path fill="#D8EFFD" d="M129 59h1a2 2 0 0 1 2 2v1h-1a2 2 0 0 1-2-2v-1z" />
        </g>
      </svg>
    );
  }
}
